import { buttonGroupClasses, Components, Theme } from '../../material';

export const MuiButtonGroup: Components<Theme>['MuiButtonGroup'] = {
  variants: [
    {
      props: { variant: 'contained' },
      style: {
        [`& .${buttonGroupClasses.firstButton}`]: {
          borderColor: 'transparent',
          marginRight: '1px',
        },
      },
    },
  ],
};
